
import { Button } from "@/components/ui/button";

export const HeroSection = () => {
  const handleGetStarted = () => {
    window.location.href = "/auth";
  };

  const handleLaunchDrillCreator = () => {
    window.location.href = "/auth";
  };

  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-8">
      <div className="md:w-1/2 space-y-6">
        <h1 className="text-4xl md:text-5xl font-bold text-primary leading-tight">
          With UPnGO Trainer Pad!
        </h1>
        <p className="text-xl text-gray-700 leading-relaxed">
          Coaches can Analyze player movement, ball trajectory, and training drills in a 3D space. Teams, FA and Drill creators can create and sell drills.
        </p>
        <div className="flex flex-col gap-12">
          <Button 
            size="lg"
            onClick={handleGetStarted}
            className="bg-primary hover:bg-primary/90 w-fit"
          >
            Get Started
          </Button>
          <div className="flex flex-col items-start gap-2">
            <p className="text-lg text-red-600 font-medium">
              Start Earning Money As A Drill Content Creator, Create Drills And Sell Them On Drill Market Place!
            </p>
            <Button 
              size="lg"
              onClick={handleLaunchDrillCreator}
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-white"
            >
              LAUNCH DRILL CREATOR
            </Button>
          </div>
        </div>
      </div>

      <div className="md:w-1/2 flex justify-center">
        <img 
          src="/lovable-uploads/717d0af3-d197-4557-b0af-338138e5d7dc.png" 
          alt="Coachies" 
          className="max-w-md w-full object-contain"
        />
      </div>
    </div>
  );
};
